export const formatCard = (card: string) =>
    card
        .replaceAll('X', '*')
        .match(/.{1,4}/g)
        .join(' ')
